import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const exportExcel = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gpsstandingbook/exportexcel' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getYeHuList = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gpsstandingbook/getyehulist' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const makePackage = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gpsstandingbook/makepackage' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const downloadPackage = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gpsstandingbook/downloadpackage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getClientYeHuList = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gpsstandingbook/GetClientYeHuList' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const makeDangerousFile = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gpsstandingbook/makedangerousfile' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const downloadDangerousFile = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gpsstandingbook/downloaddangerousfile' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const clientExportExcel = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gpsstandingbook/clientexportexcel' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

